import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  token: string | null;
  username: string | null;
  nombre: string | null;
  rol: string | null;
  passwordTemporal: boolean;
  candidatoId: number | null;
  login: (token: string, username: string, nombre: string, rol: string, passwordTemporal: boolean, candidatoId: number | null) => void;
  logout: () => void;
  markPasswordChanged: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      username: null,
      nombre: null,
      rol: null,
      passwordTemporal: false,
      candidatoId: null,
      login: (token, username, nombre, rol, passwordTemporal, candidatoId) =>
        set({ token, username, nombre, rol, passwordTemporal, candidatoId }),
      logout: () =>
        set({ token: null, username: null, nombre: null, rol: null, passwordTemporal: false, candidatoId: null }),
      markPasswordChanged: () => set({ passwordTemporal: false }),
    }),
    { name: 'arpp-jee-auth' }
  )
);
